export const table = {
  bg: {
    color: '#fcfcff',
  },
  border: {
    top: {
      left: {
        radius: '4px',
      },
      right: {
        radius: '4px',
      },
    },
    bottom: {
      left: {
        radius: '4px',
      },
      right: {
        radius: '4px',
      },
    },
  },
  th: {
    bg: {
      color: '#ffffff',
    },
    color: '#20276F',
    // color: '#232d7c',
    text: {
      transform: 'uppercase',
    },
    padding: '0 32px',
    height: '60px',
    border: {
      top: {
        left: {
          radius: '4px',
        },
        right: {
          radius: '4px',
        },
      },
      bottom: {
        left: {
          radius: '0',
        },
        right: {
          radius: '0',
        },
      },
    },
    font: {
      size: '13px',
      weight: 600,
    },
    line: {
      height: '16px',
    },
    letter: {
      spacing: '0.02px',
    },
  },
  td: {
    color: '#282933',
    padding: '0 32px',
    border: {
      top: '1px solid #efefef',
      bottom: '1px solid #fcfcff',
    },
    font: {
      size: '14px',
      weight: 400,
    },
    line: {
      height: '24px',
    },
    letter: {
      spacing: '-0.01em',
    },
  },
  // tr: {
  //   first: {
  //     child: {
  //       td: {
  //         border: {
  //           top: '1px solid #efefef',
  //         },
  //       },
  //     },
  //   },
  //   last: {
  //     child: {
  //       td: {
  //         border: {
  //           bottom: '1px solid #fcfcff',
  //         },
  //       },
  //     },
  //   },
  // },
}
